import dayjs from 'dayjs'
import { toast } from 'react-toastify'
import { v4 as uuidv4 } from 'uuid'

export const NEW_SLOT = { startTime: '09:00:00', endTime: '20:00:00' }

export const DEFAULT_WEEKLY_HOUR_MAP = {
  sunday: getDefaultWeeklyHours('Sunday', false),
  monday: getDefaultWeeklyHours('Monday'),
  tuesday: getDefaultWeeklyHours('Tuesday'),
  wednesday: getDefaultWeeklyHours('Wednesday'),
  thursday: getDefaultWeeklyHours('Thursday'),
  friday: getDefaultWeeklyHours('Friday'),
  saturday: getDefaultWeeklyHours('Saturday', false),
}

export function getDefaultWeeklyHours(title, available = true) {
  return { available: available, title: title, slotList: available ? [NEW_SLOT] : null }
}

export const NEW_SCHEDULE_OBJECT = {
  id: `clinic_schedule-${uuidv4()}`,
  title: 'Clinic Schedule',
  weeklyHourMap: DEFAULT_WEEKLY_HOUR_MAP,
}

export function validateClinicFunction(clinicObject) {
  const schedules = clinicObject.schedules
  const schedulesValidation = schedules.map((schedule) => {
    const weeklyHourMap = schedule.weeklyHourMap
    const validateWeeklyHourMap = Object.entries(weeklyHourMap || {}).every(
      ([dayKey, daySchedule]) => {
        if (!daySchedule.available) {
          return true
        }
        const validateSLotList = (daySchedule?.slotList || [])?.every((slot, idx) => {
          const startTimeEndTimeNoConflict =
            dayjs(slot.startTime, 'HH:mm:ss') < dayjs(slot.endTime, 'HH:mm:ss')
          var overLapPrev = false
          if (idx !== 0) {
            overLapPrev =
              dayjs(slot.startTime, 'HH:mm:ss') <
              dayjs(daySchedule?.slotList?.[idx - 1].endTime, 'HH:mm:ss')
          }
          console.log({ startTimeEndTimeNoConflict, overLapPrev })
          return startTimeEndTimeNoConflict && !overLapPrev
        })

        return validateSLotList
      },
    )

    return validateWeeklyHourMap
  })
  if (!schedulesValidation.every((sch) => sch)) {
    toast.error('Entered schedules are invalid, please review')
  }
  return {
    schedules: schedulesValidation.every((sch) => sch),
    schedulesValidationArray: schedulesValidation,
  }
}
